import {connect} from 'react-redux';
import {isEmpty, isFunction} from 'lodash';
import {createStructuredSelector} from 'reselect';

import ProfileDetailsSection from '/component/partial/profile/ProfileDetailsSection';
import {
  PROFILE_FIELD_COACH,
  PROFILE_FIELD_OPTAVIA_ID,
} from '/enum/profileField.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {coachFullNameById, coachIdById} from '/redux/selector/client.selector';
import {withHOC} from '/util/hoc.util';

export default withHOC(
  connect(
    createStructuredSelector({
      coachId: coachIdById,
      coachName: coachFullNameById,
    }),
    null,
    (stateProps, dispatchProps, ownProps) => ({
      ...stateProps,
      ...dispatchProps,
      ...ownProps,
      fields: [PROFILE_FIELD_OPTAVIA_ID, PROFILE_FIELD_COACH],
      optaviaId: ownProps.clientId,
      onCoachPress: isEmpty(stateProps.coachId)
        ? null
        : () => {
            if (isFunction(ownProps.onCoachPress)) {
              ownProps.onCoachPress({coachId: stateProps.coachId});
            }
          },
    }),
  ),
  withTranslation('screen.clientProfile.section.details'),
)(ProfileDetailsSection);
